import { AggProjection, Expression } from '@fabric-ui/components';

export enum ScoreMode {
  REDUCE = -1,
  RAISE = 1,
}

export type ScoringFilter = {
  filter: { expression: Expression };
  score: number;
};

export type ScoringFactor = {
  name: string;
  minPoints: number;
  maxPoints: number;
  fieldName?: string;
  fallBackScore: number;
  scoringFilters: ScoringFilter[];
  added?: boolean;
};

export type EntitiesFactor = {
  projectionId: AggProjection;
  minPoints: number;
  maxPoints: number;
  factors: ScoringFactor[];
};

export type SideBarIndexes = { entitiesFactorIndex: number; factorIndex: number };

export type ScoringFilterErrors = { value?: string; score?: string };
export type ScoringFiltersErrors = {
  scoringFilters?: { [key in number | 'else']?: ScoringFilterErrors };
};
export type ScoringErrors = { [K in keyof Omit<ScoringFactor, 'scoringFilters'>]?: string } & ScoringFiltersErrors;
